import axios from "axios"
import { logOut } from "../actions/AuthAction";
import store from '../store/ReduxStore';

const API = axios.create({baseURL: process.env.REACT_APP_API_BASE_URL, withCredentials: true});

API.interceptors.response.use(
    response => response, 
    error => {
        if (error.response && error.response.status === 401) {
            console.log("Token expired, logging out user...");

            // Dispatch logout action
            store.dispatch(logOut());
        }
        return Promise.reject(error);
    }
);

export const checkDeepLinkAccess = (targetId, targetType, userId) =>
    API.get(`/deeplink/check/${targetType}/${targetId}/${userId}`);